import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaBuilding, FaUserTie } from "react-icons/fa";

const carouselImages = [
	"https://res.cloudinary.com/dmwvkjqsn/image/upload/f_auto,q_auto/v1/AccountingBusinessCDN/a8ot1jkfbwycwh5ibbkq",
	"https://res.cloudinary.com/dmwvkjqsn/image/upload/f_auto,q_auto/v1/AccountingBusinessCDN/mtrpgcit3yd4nsxzhg29",
	"https://res.cloudinary.com/dmwvkjqsn/image/upload/f_auto,q_auto/v1/AccountingBusinessCDN/co9egnxtsuwsmmjnyrrh",
	"https://res.cloudinary.com/dmwvkjqsn/image/upload/f_auto,q_auto/v1/AccountingBusinessCDN/uxqwg576i9m2ldcwptsh",
];

const AboutUs = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleAboutUsClick = () => {
		navigate("/about-us");
	};

	return (
		<section
			id="about"
			className="bg-gradient-to-b from-white to-cream dark:from-slate-800 dark:to-slate-900 dark:text-white py-20 relative overflow-hidden"
		>
			{/* Background decoration */}
			<div className="absolute top-1/2 -left-48 w-96 h-96 bg-accent/8 rounded-full blur-3xl"></div>
			<div className="absolute bottom-0 right-0 w-80 h-80 bg-slate-400/10 rounded-full blur-3xl"></div>

			<div className="container mx-auto px-6 md:px-12 relative z-10">
				{/* Section header */}
				<div className="text-center mb-16">
					<span className="text-accent font-semibold text-sm tracking-wider animate-fade-in">
						{t("about.welcome")}
					</span>
					<h2 className="section-title mt-3 animate-fade-in-up">
						<span className="gradient-text">{t("about.title")}</span>
					</h2>
				</div>

				<div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
					{/* Carousel section */}
					<div className="lg:w-1/2 w-full animate-slide-in-left">
						<div className="relative">
							{/* Decorative frame */}
							<div className="absolute -top-4 -left-4 w-full h-full border-2 border-accent/30 rounded-2xl"></div>
							<div className="absolute -bottom-4 -right-4 w-full h-full bg-gradient-to-br from-slate-600/20 to-accent/15 rounded-2xl"></div>

							<Carousel
								autoPlay
								infiniteLoop
								showThumbs={false}
								showIndicators={true}
								showStatus={false}
								interval={4000}
								transitionTime={600}
								className="relative z-10 rounded-2xl overflow-hidden shadow-card-hover"
							>
								{carouselImages.map((src, index) => (
									<div key={index} className="relative">
										<img
											src={src}
											alt={t("about.officeAlt")}
											className="object-cover w-full h-80 md:h-96"
										/>
										<div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
									</div>
								))}
							</Carousel>
						</div>
					</div>

					{/* Content section */}
					<div className="lg:w-1/2 space-y-6 animate-slide-in-right">
						{/* Company info card */}
						<div className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-card border border-gray-100 dark:border-slate-700 hover:shadow-card-hover transition-shadow duration-300">
							<div className="flex items-center gap-4 mb-4">
								<div className="w-12 h-12 rounded-xl bg-gradient-to-br from-slate-700 to-slate-500 flex items-center justify-center">
									<FaBuilding className="text-white text-xl" />
								</div>
								<h3 className="text-xl font-bold dark:text-white">{t("about.welcome")}</h3>
							</div>
							<p className="text-gray-600 dark:text-gray-300 leading-relaxed">
								{t("about.description")}
							</p>
						</div>

						{/* Founder info card */}
						<div className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-card border border-gray-100 dark:border-slate-700 hover:shadow-card-hover transition-shadow duration-300">
							<div className="flex items-center gap-4 mb-4">
								<div className="w-12 h-12 rounded-xl bg-gradient-to-br from-accent to-orange-400 flex items-center justify-center">
									<FaUserTie className="text-white text-xl" />
								</div>
								<h3 className="text-xl font-bold dark:text-white">{t("about.founderTitle")}</h3>
							</div>
							<p className="text-gray-600 dark:text-gray-300 leading-relaxed">
								{t("about.founderDescription")}
							</p>
						</div>
					</div>
				</div>

				{/* CTA Button */}
				<div className="text-center mt-12 animate-fade-in-up animate-delay-300">
					<button
						onClick={handleAboutUsClick}
						className="primary-btn text-lg px-8 py-4"
					>
						{t("services.learnMore")}
					</button>
				</div>
			</div>
		</section>
	);
};

export default AboutUs;
